export class Facility {
  code: string;
  name: string;
}
